import ProducersRoutes from "./producers";

export default [...ProducersRoutes];
